export function isBoolean(item: unknown): item is boolean {
	return item === true || item === false;
}
